import { render } from "./XButton.vue?vue&type=template&id=e8237304&scoped=true"
import script from "./XButton.vue?vue&type=script&lang=js"
export * from "./XButton.vue?vue&type=script&lang=js"

import "./XButton.vue?vue&type=style&index=0&id=e8237304&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8237304"]])

export default __exports__